import { render } from "./SplitByBioResults.vue?vue&type=template&id=84d99f40&scoped=true&lang=pug"
import script from "./SplitByBioResults.vue?vue&type=script&lang=js"
export * from "./SplitByBioResults.vue?vue&type=script&lang=js"

import "./SplitByBioResults.vue?vue&type=style&index=0&id=84d99f40&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d99f40"]])

export default __exports__